<div class="bulk-action-results">
  <div class="bulk-action-results__page-title bold">Bulk Change</div>

  <div class="bulk-action-results__section-title bold">BULK UPDATE VALIDATION SUMMARY</div>

  <div class="bulk-action-results__banner" *ngIf="summary">
    <span class="bulk-action-results__banner-item"><strong>Job ID :</strong>&nbsp;{{ summary.jobId }}</span>
    <span class="bulk-action-results__banner-item">
      <strong>Type of Update :</strong>&nbsp;{{ summary.actionType }}
    </span>
    <span class="bulk-action-results__banner-item"><strong>Phase :</strong>&nbsp;{{ summary.phase }}</span>
  </div>

  <table class="bulk-action-results__summary" *ngIf="summary">
    <thead>
      <tr>
        <th>TYPE</th>
        <th>DETAILS</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Bulk Actions Run Date</td>
        <td>{{ summary.runDate | date:"MM/dd/yyyy HH:mm:ss" }}</td>
      </tr>
      <tr>
        <td>Total Chases</td>
        <td>{{ summary.total }}</td>
      </tr>
      <tr>
        <td>{{ isExecutePhase ? "Execute Success" : "Validation Success" }}</td>
        <td>{{ summary.success }}</td>
      </tr>
      <tr>
        <td>{{ isExecutePhase ? "Execute Fail" : "Validation Fail" }}</td>
        <td>{{ summary.fail }}</td>
      </tr>
    </tbody>
  </table>

  <div class="bulk-action-results__actions" *ngIf="!isExecutePhase && summary">
    <app-button
      classes="primary"
      text="Execute"
      [disabled]="!canExecute"
      (onClick)="openExecuteConfirm()">
    </app-button>
  </div>

  <div class="bulk-action-results__section-title bold">VALIDATED RECORDS</div>

  <app-server-grid
    [configuration]="gridConfiguration"
    [request]="gridRequest"
    [refresh]="gridRefresh">
  </app-server-grid>

  <app-confirmation-modal
    [(visible)]="showExecuteConfirm"
    header="Execute Bulk Action"
    acceptText="Execute"
    rejectText="Cancel"
    (onYes)="execute()">
    <p>This will run the move/reassign on the {{ summary?.success }} validated chase(s). Continue?</p>
  </app-confirmation-modal>
</div>
